
(function() {
  

  
  const CONFIG = {
    presetText: "Neon Bar",
    iconIndex: 0,
    addIcon: true,
    
    enabledOn: "specific",
    
    specificProducts: [],
    
    specificCollections: [
      "custom-neon-bar-sign"
    ]
  };
  
  
  function shouldRun() {
    const path = window.location.pathname;
    
    switch(CONFIG.enabledOn) {
      case "all":
        return true;
      case "products":
        return path.includes('/products/');
      case "collections":
        return path.includes('/collections/');
      case "specific":
        if (path.includes('/products/')) {
          const productHandle = path.split('/products/')[1]?.split('?')[0]?.split('/')[0];
          if (CONFIG.specificProducts.includes(productHandle)) {
            console.log('✅ Running on specific product:', productHandle);
            return true;
          }
        }
        if (path.includes('/collections/')) {
          const collectionHandle = path.split('/collections/')[1]?.split('?')[0]?.split('/')[0];
          if (CONFIG.specificCollections.includes(collectionHandle)) {
            console.log('✅ Running on specific collection:', collectionHandle);
            return true;
          }
        }
        console.log('ℹ️ Not running - not on specified products/collections');
        return false;
      default:
        return false;
    }
  }
  
  if (!shouldRun()) {
    console.log('ℹ️ Neon preset not active on this page');
    return;
  }
  
  console.log('🎨 Neon Customizer: Waiting for app to load...');
  
  
  let hasRun = false;
  
  function trySetText() {
    if (hasRun) return;
    
    const editor = document.querySelector('.tiptap.ProseMirror[contenteditable="true"]');
    
    if (editor && editor.querySelector('p')) {
      console.log('✅ Customizer loaded! Setting text...');
      hasRun = true;
      setPresetText();
    }
  }
  
  trySetText();
  
  if (!hasRun) {
    console.log('⏳ Customizer not loaded yet, watching for it...');
    
    const observer = new MutationObserver(() => {
      trySetText();
      if (hasRun) {
        observer.disconnect();
      }
    });
    
    observer.observe(document.body, {
      childList: true,
      subtree: true
    });
    
    let scrollChecked = false;
    window.addEventListener('scroll', () => {
      if (!scrollChecked) {
        scrollChecked = true;
        setTimeout(trySetText, 1000);
      }
    }, { once: true });
    
    setTimeout(() => {
      observer.disconnect();
      if (!hasRun) {
        console.log('⚠️ Customizer never appeared after 2 minutes');
      }
    }, 120000);
  }
  

  function setPresetText() {
    const editor = document.querySelector('.tiptap.ProseMirror[contenteditable="true"]');
    
    if (!editor) {
      console.log('❌ Editor not found');
      return false;
    }
    
    const paragraph = editor.querySelector('p');
    
    if (!paragraph) {
      console.log('❌ Paragraph not found');
      return false;
    }
    
    paragraph.classList.remove('is-empty', 'is-editor-empty');
    paragraph.innerHTML = '';
    
    let existingOuterSpan = paragraph.querySelector('span[data-fontid]');
    let existingMiddleSpan = existingOuterSpan ? existingOuterSpan.querySelector('span[data-colourid]') : null;
    let existingInnerSpan = existingMiddleSpan ? existingMiddleSpan.querySelector('span[data-tubecolourid]') : null;
    
    const fontId = existingOuterSpan ? existingOuterSpan.getAttribute('data-fontid') : '172087';
    const colourId = existingMiddleSpan ? existingMiddleSpan.getAttribute('data-colourid') : '';
    const tubeColourId = existingInnerSpan ? existingInnerSpan.getAttribute('data-tubecolourid') : '103964';
    
    const outerSpan = document.createElement('span');
    outerSpan.setAttribute('data-fontid', fontId);
    
    const middleSpan = document.createElement('span');
    middleSpan.setAttribute('data-colourid', colourId);
    
    const innerSpan = document.createElement('span');
    innerSpan.setAttribute('data-tubecolourid', tubeColourId);
    
    const textNode = document.createTextNode(CONFIG.presetText);
    innerSpan.appendChild(textNode);
    
    middleSpan.appendChild(innerSpan);
    outerSpan.appendChild(middleSpan);
    paragraph.appendChild(outerSpan);
    
    editor.dispatchEvent(new Event('input', { bubbles: true, cancelable: true }));
    
    const container = document.querySelector('#npc-text-area');
    if (container) {
      container.dispatchEvent(new Event('input', { bubbles: true }));
    }
    
    editor.focus();
    
    console.log('✅ Text inserted:', CONFIG.presetText);
    
    if (CONFIG.addIcon) {
      setTimeout(() => {
        addIconInvisibly(CONFIG.iconIndex);
      }, 800);
    }
    
    return true;
  }
  
  function addIconInvisibly(iconIndex) {
    const iconButton = document.querySelector('button.npc-button-icon[aria-haspopup="dialog"]');
    
    if (!iconButton) {
      console.log('⚠️ Icon button not found');
      return;
    }
    
    const style = document.createElement('style');
    style.id = 'hide-icon-popup';
    style.textContent = `
      [role="dialog"][id*="radix"] {
        opacity: 0 !important;
        pointer-events: auto !important;
      }
    `;
    document.head.appendChild(style);
    
    console.log('🔘 Clicking icon picker (invisibly)...');
    iconButton.click();
    
    setTimeout(() => {
      const iconButtons = document.querySelectorAll('[role="dialog"] button[style*="icon-font"]');
      
      if (iconButtons[iconIndex]) {
        console.log(`✅ Clicking icon #${iconIndex}`);
        iconButtons[iconIndex].click();
        
        setTimeout(() => {
          document.body.click();
          
          setTimeout(() => {
            const hideStyle = document.getElementById('hide-icon-popup');
            if (hideStyle) hideStyle.remove();
            console.log('✅ Icon added invisibly');
          }, 200);
        }, 100);
      } else {
        console.log(`❌ Icon #${iconIndex} not found`);
        const hideStyle = document.getElementById('hide-icon-popup');
        if (hideStyle) hideStyle.remove();
      }
    }, 400);
  }
})();